/**
 * @generated SignedSource<<ebf3e005a2d5e10470eed4f30ddfe3a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TVEmployeeRoleDialog_EmployeeConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"TVEmployeeRoleDialog_EmployeeItem">;
    };
  }>;
  readonly " $fragmentType": "TVEmployeeRoleDialog_EmployeeConnection";
};
export type TVEmployeeRoleDialog_EmployeeConnection$key = {
  readonly " $data"?: TVEmployeeRoleDialog_EmployeeConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"TVEmployeeRoleDialog_EmployeeConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TVEmployeeRoleDialog_EmployeeConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeConnectionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TVEmployeeRoleDialog_EmployeeItem"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmployeeConnection",
  "abstractKey": null
};

(node as any).hash = "bb72eb753f280474f1ca911a4d823a16";

export default node;
